// Cache DOM parser for reuse
let tempDiv;
const getTextExtractor = () => {
  if (!tempDiv) {
    tempDiv = document.createElement("div");
  }
  return tempDiv;
};

const extractTextFromHTML = (htmlContent) => {
  const extractor = getTextExtractor();
  extractor.innerHTML = htmlContent;
  const text = extractor.textContent || extractor.innerText || "";
  extractor.innerHTML = ""; // Clear for next use
  return text;
};

// Cache audio element and track interaction state
let notificationAudio;
let audioEnabled = false;

const getNotificationAudio = () => {
  if (!notificationAudio) {
    notificationAudio = new Audio("/notification_new.mp3");
    notificationAudio.volume = 1;
  }
  return notificationAudio;
};

// Enable audio after first user interaction
const enableAudioOnInteraction = () => {
  if (!audioEnabled) {
    const audio = getNotificationAudio();
    // Preload and test audio
    audio.play().then(() => {
      audio.pause();
      audio.currentTime = 0;
      audioEnabled = true;
    }).catch(() => {
      // Audio still not allowed, will try again on next interaction
    });
  }
};

// Add event listeners for user interaction
if (typeof document !== 'undefined') {
  ['click', 'touchstart', 'keydown'].forEach(event => {
    document.addEventListener(event, enableAudioOnInteraction, { once: true, passive: true });
  });
}

// Cache user data to avoid repeated localStorage access
const getUserData = () => {
  const authUserData = localStorage.getItem("userData");
  return authUserData ? JSON.parse(authUserData) : {};
};

// Optimized mute check
const isMuted = (list, routeId) => {
  if (!Array.isArray(list) || list.length === 0) return false;
  const routeIdStr = routeId.toString();
  return list.some(id => id.toString() === routeIdStr);
};

// Optimized early exit check
const shouldSkipNotification = (authUser, authUser2, message_type, routeId, tagged_users, sender) => {
  const authUserId = authUser._id?.toString();
  const senderStr = sender ? sender._id?.toString() || sender.toString() : null;

  // Check if sender is the current user
  if (senderStr && senderStr === authUserId) {
    return true;
  }

  // Check mute status
  if (message_type === "message" && isMuted(authUser2?.mute_users, routeId)) {
    return true;
  }

  if (message_type === "channel" && isMuted(authUser2?.mute_channels, routeId)) {
    return true;
  }

  // tagged_users check only applies to non-notification-channel messages
  // (notification channels broadcast to all members regardless of tagging)
  if (!authUser2?.isNotificationChannel && tagged_users?.length > 0) {
    const taggedStrings = tagged_users.map((id) => id?.toString());
    if (!taggedStrings.includes(authUserId)) {
      return true;
    }
  }

  return false;
};

const handleNotificationClick = (messageType, routeId, parentMessageId) => {
  localStorage.setItem("current_id", routeId);
  let targetUrl;
  if (messageType === "message") {
    targetUrl = `/elsnertech/message/${routeId}`;
  } else if (messageType === "notification") {
    targetUrl = `/elsnertech/notifications/${routeId}`;
    if (parentMessageId) {
      targetUrl += `?msg=${encodeURIComponent(parentMessageId)}`;
    }
  } else {
    targetUrl = `/elsnertech/channels/${routeId}`;
  }
  const appUrl = `https://e-connect.elsner.com${targetUrl}`;

  if (window.location.href.includes("e-connect.elsner.com")) {
    if (!window.location.href.includes(targetUrl)) {
      if (typeof window.updateRoute === "function") {
        window.updateRoute(targetUrl);
      } else {
        window.location.href = appUrl;
      }
    }
    window.focus();
  } else {
    window.open(appUrl);
  }
};

export const showBrowserNotification = async (
  title,
  msg,
  type,
  authUser,
  sender,
  message_type,
  routeId,
  tagged_users,
  parentMessageId = ""
) => {
  // Get cached user data
  const authUser2 = getUserData();

  // Early exit check - optimized for performance
  if (shouldSkipNotification(authUser, authUser2, message_type, routeId, tagged_users, sender)) {
    return;
  }

  // Check notification permission first
  if (Notification.permission === "denied") {
    return;
  }

  // Request permission if needed
  if (Notification.permission === "default") {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      return;
    }
  }

  try {
    // Play audio notification only if enabled
    if (audioEnabled) {
      const audio = getNotificationAudio();
      audio.currentTime = 0; // Reset to beginning for repeated plays
      audio.play().catch(error => {
        console.warn("Audio playback failed:", error.message);
        audioEnabled = false; // Reset flag to try enabling again
      });
    }

    // Create and show notification
    const notificationOptions = {
      body: extractTextFromHTML(msg),
      icon: "/favicon-Defualt.png",
    };

    const notification = new Notification(title, notificationOptions);
    notification.onclick = () => handleNotificationClick(message_type, routeId, parentMessageId);
    
    // Auto-close notification after 5 seconds to prevent clutter
    setTimeout(() => {
      try {
        notification.close();
      } catch (e) {
        // Notification might already be closed
      }
    }, 5000);

  } catch (error) {
    console.error("Notification error:", error);
  }
};